<template>
  <div>
    <div>
      <slot v-bind:pageData="pageData"></slot>
    </div>
    <div class="mt-5 row justify-content-center">
      <app-button class="col--auto offset--auto" btn-type="ghost" layout="icon" icon="angle-left" icon-position="center"
                  :disabled="!canGoBack" @click="onBack" />
      <app-button v-for="(item, index) in totalPages" :key="`${index}-page`" class="col--auto" btn-type="ghost" layout="text"
                  :disabled="currentPage === index" @click="goToPage(index)">
        {{ index + 1 }}
      </app-button>
      <app-button class="col--auto" btn-type="ghost" layout="icon" icon="angle-right" icon-position="center"
                :disabled="!canGoNext" @click="onNext"
      />
    </div>
  </div>
</template>

<script>
import AppButton from "../AppButton.vue";

export default {
  name: "Pagination",
  components: { AppButton },
  props: {
    'items': { 'type': Array, 'required': true, 'default': [] },
    'perPage': { 'type': Number, 'required': false, 'default': 1 }
  },
  data() {
    return {
      'currentPage': 0,
      'pageData': [],
    }
  },
  watch: {
    items(newValue) {
      if (newValue.length === 0) {
        this.pageData = []
        this.currentPage = 0

        return;
      }

      if (this.currentPage > this.totalPages) {
        this.currentPage = 0;
      }

      this.changePage();
    }
  },
  computed: {
    canGoBack() {
      return this.currentPage > 0;
    },
    canGoNext() {
      return this.currentPage < this.totalPages - 1;
    },
    totalPages() {
      return Math.ceil(this.items.length / this.perPage);
    }
  },
  methods: {
    onBack() {
      if (this.canGoBack) {
        this.currentPage--;
        this.changePage()
      }
    },
    onNext() {
      if (this.canGoNext) {
        this.currentPage++;
        this.changePage()
      }
    },
    goToPage(index) {
      if(this.items[index] != null) {
        this.currentPage = index
        this.changePage()
      }
    },
    changePage() {
      const from = (this.currentPage) * this.perPage;
      const to = from + this.perPage;

      this.pageData = this.items.slice(from, to);
    }
  },
  mounted() {
    this.changePage()
  }
}
</script>

<style scoped>

</style>